// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
import './primarybutton.scss'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const PrimaryButton = ({ btnText, containerStyle, onPress, labelStyle, isLink, linkText, id }) => {
  const onButtonCLick = () => {
    onPress()
  }
  return (
    <>
      {isLink ?
        <a className='primary-button-container' style={containerStyle} href={linkText} onClick={onButtonCLick}>
          <label className='primary-button-text' style={labelStyle}>
            {btnText}
          </label>
        </a>
      : <div id={id} className='primary-button-container' style={containerStyle} onClick={onButtonCLick}>
          <label className='primary-button-text' style={labelStyle}>
            {btnText}
          </label>
        </div>
      }
    </>
  )
}
